import React, { useContext, useCallback } from 'react';
import { CommentContext } from '../CommentContext';
import CommentBox from '../../../CommentBox';
var EditingCommentContent = function (_a) {
    var currentUser = _a.currentUser, className = _a.className, canPostComment = _a.canPostComment, onCommentUpdated = _a.onCommentUpdated;
    var _b = useContext(CommentContext), comment = _b.comment, setEditingState = _b.setEditingState;
    var onCloseEditor = useCallback(function () {
        setEditingState('none');
    }, [setEditingState]);
    var onEditDone = useCallback(function (result) {
        setEditingState('none');
        onCommentUpdated && result.comment && onCommentUpdated(result);
    }, [setEditingState, onCommentUpdated]);
    return (React.createElement(CommentBox, { className: className, onPublishSuccess: onEditDone, id: "edit-" + comment.commentId, commentableType: comment.typeId, commentableItemId: comment.itemId, user: currentUser, editComment: comment, autoFocus: true, onClose: onCloseEditor, canPostComment: canPostComment }));
};
EditingCommentContent.displayName = 'EditingCommentContent';
export default EditingCommentContent;
//# sourceMappingURL=EditingCommentContent.js.map